import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/header-logo.png'
import _imports_1 from '@/assets/q.svg'
import _imports_2 from '@/assets/list.svg'
import _imports_3 from '@/assets/copy.svg'
import _imports_4 from '@/assets/exchange.svg'
import _imports_5 from '@/assets/arrow-right.svg'
import _imports_6 from '@/assets/add.svg'
import _imports_7 from '@/assets/logo_big.png'
import _imports_8 from '@/assets/economy.svg'
import _imports_9 from '@/assets/safety.svg'
import _imports_10 from '@/assets/efficient.svg'
import _imports_11 from '@/assets/right.svg'
import _imports_12 from '@/assets/ku.svg'
import _imports_13 from '@/assets/ku-b.svg'
import _imports_14 from '@/assets/rocket.svg'
import _imports_15 from '@/assets/rocket-b.svg'
import _imports_16 from '@/assets/book.svg'
import _imports_17 from '@/assets/book-b.svg'
import _imports_18 from '@/assets/ex.svg'
import _imports_19 from '@/assets/ex-b.svg'


const _hoisted_1 = { class: "main_body" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "phone_header" }
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  id: "energy",
  class: "energy"
}
const _hoisted_6 = { class: "form" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "energyBalance disabled" }
const _hoisted_10 = { class: "item mondyDiv" }
const _hoisted_11 = { class: "address disabled" }
const _hoisted_12 = {
  id: "exchange",
  class: "exchange exchangeDiv"
}
const _hoisted_13 = {
  class: "changeButton",
  style: {"display":"none"}
}
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { class: "form" }
const _hoisted_17 = { class: "input num1" }
const _hoisted_18 = { class: "icon" }
const _hoisted_19 = { class: "input num2" }
const _hoisted_20 = { class: "pay" }
const _hoisted_21 = { class: "address" }
const _hoisted_22 = {
  id: "Uchange",
  class: "exchange CnyEx exchangeDiv"
}
const _hoisted_23 = {
  class: "changeButton",
  style: {"display":"none"}
}
const _hoisted_24 = { class: "h4" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { class: "info" }
const _hoisted_27 = { class: "form" }
const _hoisted_28 = { class: "input num1" }
const _hoisted_29 = { class: "icon" }
const _hoisted_30 = { class: "input num2" }
const _hoisted_31 = { class: "pay" }
const _hoisted_32 = { class: "address gassFei" }
const _hoisted_33 = { class: "note" }
const _hoisted_34 = {
  id: "UchangePhone",
  class: "CnyExPhone"
}
const _hoisted_35 = { class: "rate" }
const _hoisted_36 = { class: "price" }
const _hoisted_37 = { class: "date" }
const _hoisted_38 = { class: "form" }
const _hoisted_39 = { class: "form-in" }
const _hoisted_40 = { class: "result" }
const _hoisted_41 = { class: "result-price" }
const _hoisted_42 = {
  id: "signatures",
  class: "signatures"
}
const _hoisted_43 = { class: "item" }
const _hoisted_44 = { class: "info" }
const _hoisted_45 = { class: "form" }
const _hoisted_46 = { class: "input num1" }
const _hoisted_47 = { class: "input num2" }
const _hoisted_48 = { class: "info2" }
const _hoisted_49 = { class: "form" }
const _hoisted_50 = { class: "input num1" }
const _hoisted_51 = { class: "input num2" }
const _hoisted_52 = {
  id: "record",
  class: "record"
}
const _hoisted_53 = { class: "recordDiv" }
const _hoisted_54 = { class: "list" }
const _hoisted_55 = { style: {"height":"400px","overflow":"hidden"} }
const _hoisted_56 = { class: "isPc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[88] || (_cache[88] = _createElementVNode("div", { class: "main_title" }, [
      _createElementVNode("div", { class: "h3" }, "TRON 转账次数购买"),
      _createElementVNode("div", { class: "h4" }, "简单方便 帮你省钱")
    ], -1)),
    _createElementVNode("header", {
      class: _normalizeClass([{'scrolled-header': _ctx.isScrolled}, "header"])
    }, [
      _createElementVNode("nav", null, [
        _cache[43] || (_cache[43] = _createElementVNode("div", { class: "log" }, [
          _createElementVNode("img", { src: _imports_0 })
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            href: "#energy",
            class: _normalizeClass({ 'active': _ctx.currentSection === 'energy' }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToSection($event, 'energy')))
          }, "购买能量", 2),
          _createElementVNode("a", {
            href: "#exchange",
            class: _normalizeClass({ 'active': _ctx.currentSection === 'exchange' }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollToSection($event, 'exchange')))
          }, "TRX兑换", 2),
          _createElementVNode("a", {
            href: "#Uchange",
            class: _normalizeClass({ 'active': _ctx.currentSection === 'Uchange' }),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollToSection($event, 'Uchange')))
          }, "USDT汇率", 2),
          _createElementVNode("a", {
            href: "#signatures",
            class: _normalizeClass({ 'active': _ctx.currentSection === 'signatures' }),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollToSection($event, 'signatures')))
          }, "钱包多签", 2),
          _createElementVNode("a", {
            href: "#record",
            class: _normalizeClass({ 'active': _ctx.currentSection === 'record' }),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollToSection($event, 'record')))
          }, "最新接收记录", 2),
          _createElementVNode("a", {
            href: "#about",
            class: _normalizeClass({ 'active': _ctx.currentSection === 'about' }),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.scrollToSection($event, 'about')))
          }, "平台介绍", 2),
          _createElementVNode("a", {
            href: "#faqDiv",
            class: _normalizeClass({ 'active': _ctx.currentSection === 'faqDiv' }),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.scrollToSection($event, 'faqDiv')))
          }, "常见问题", 2)
        ]),
        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "lang" }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          }),
          _createElementVNode("span", null, "English")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "menu-icon",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.drawerVisible = true))
        }, _cache[45] || (_cache[45] = [
          _createElementVNode("img", {
            src: _imports_2,
            alt: ""
          }, null, -1)
        ])),
        _createVNode(_component_el_drawer, {
          "model-value": _ctx.drawerVisible,
          direction: "rtl",
          "before-close": _ctx.handleClose,
          size: "50vw",
          "show-close": false,
          style: {"background":"#30007a"}
        }, {
          header: _withCtx(({ titleId, titleClass }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["log", titleClass]),
              id: titleId
            }, _cache[46] || (_cache[46] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1)
            ]), 10, _hoisted_4)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_menu, {
              class: "m-el-menu",
              style: {"padding":"0px","background":"#30007a"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: "1" }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "#energy",
                      class: _normalizeClass({ 'active': _ctx.currentSection === 'energy' }),
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.scrollToSection($event, 'energy')))
                    }, "购买能量", 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "2" }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "#exchange",
                      class: _normalizeClass({ 'active': _ctx.currentSection === 'exchange' }),
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.scrollToSection($event, 'exchange')))
                    }, "TRX兑换", 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "3" }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "#UchangePhone",
                      class: _normalizeClass({ 'active': _ctx.currentSection === 'UchangePhone' }),
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.scrollToSection($event, 'UchangePhone')))
                    }, "USDT汇率", 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "4" }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "#signatures",
                      class: _normalizeClass({ 'active': _ctx.currentSection === 'signatures' }),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.scrollToSection($event, 'signatures')))
                    }, "钱包多签", 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "5" }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "#record",
                      class: _normalizeClass({ 'active': _ctx.currentSection === 'record' }),
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.scrollToSection($event, 'record')))
                    }, "最新接收记录", 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "6" }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "#about",
                      class: _normalizeClass({ 'active': _ctx.currentSection === 'about' }),
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.scrollToSection($event, 'about')))
                    }, "平台介绍", 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: "7" }, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      href: "#faqDiv",
                      class: _normalizeClass({ 'active': _ctx.currentSection === 'faqDiv' }),
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.scrollToSection($event, 'faqDiv')))
                    }, "常见问题", 2)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model-value", "before-close"])
      ])
    ], 2),
    _createElementVNode("main", null, [
      _cache[86] || (_cache[86] = _createElementVNode("div", { class: "moving" }, [
        _createElementVNode("div", { class: "moving-text" }, "注意：TRX价格持续上涨，能量池供应紧张，购买请仔细查看能量池余量是否足够！ 注意：TRX价格持续上涨，能量池供应紧张，购买请仔细查看能量池余量是否足够！")
      ], -1)),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[54] || (_cache[54] = _createElementVNode("div", { class: "item explain" }, [
            _createElementVNode("h5", { "data-v-2f9b8540": "" }, "波场租能量 - 操作说明"),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, "正常情况下，波场（TRON）每笔智能合约交易需燃烧约 13.6TRX或65000能量才能发起转账。"),
              _createElementVNode("li", null, "向平台支付对应的TRX，系统收到后会3秒内将对应的能量发送到您支付的地址上。"),
              _createElementVNode("li", null, "接下来您转账过程中将不再燃烧TRX（能量已抵扣），单笔交易立剩90%手续费。"),
              _createElementVNode("li", { class: "lastL" }, "请注意根据波场（TRON）规则，如果对方地址USDT为0，交易需要双倍131000的能量")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _cache[50] || (_cache[50] = _createElementVNode("h5", null, [
              _createElementVNode("i", null, "01")
            ], -1)),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _cache[48] || (_cache[48] = _createElementVNode("strong", null, " 能量价格 ", -1)),
                _createElementVNode("span", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.config.ENERGY_PRICE_LEFT) + " TRX = ", 1),
                  _createElementVNode("i", null, _toDisplayString(_ctx.config.ENERGY_PRICE_RIGHT), 1),
                  _cache[47] || (_cache[47] = _createTextVNode(" 能量 "))
                ])
              ]),
              _createElementVNode("li", null, [
                _cache[49] || (_cache[49] = _createElementVNode("strong", null, "当前能量池可购买数量", -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.config.ENERGY_BALANCE), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[53] || (_cache[53] = _createElementVNode("h5", null, [
              _createElementVNode("i", null, "02")
            ], -1)),
            _createElementVNode("ul", null, [
              _cache[52] || (_cache[52] = _createElementVNode("li", null, [
                _createElementVNode("strong", null, " 支付 "),
                _createElementVNode("span", { class: "info saved" }, " 向下方地址转账对应TRX，3秒后再去转账即可免除手续费。 ")
              ], -1)),
              _createElementVNode("li", null, [
                _cache[51] || (_cache[51] = _createElementVNode("strong", null, "平台收款地址", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.config.collection_energy_address), 1),
                  _createElementVNode("img", {
                    src: _imports_3,
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.copyText(_ctx.config.collection_energy_address||'')))
                  })
                ])
              ])
            ])
          ]),
          _cache[55] || (_cache[55] = _createElementVNode("div", { class: "item explain2" }, [
            _createElementVNode("h5", { "data-v-2f9b8540": "" }, "能量兑换 - 操作说明"),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, "正常情况下，波场（TRON）每笔智能合约交易需燃烧约 13.6TRX或65000能量才能发起转账。"),
              _createElementVNode("li", null, "向平台支付对应的TRX，系统收到后会3秒内将对应的能量发送到您支付的地址上。"),
              _createElementVNode("li", null, "接下来您转账过程中将不再燃烧TRX（能量已抵扣），单笔交易立剩90%手续费。"),
              _createElementVNode("li", { class: "lastL" }, "请注意根据波场（TRON）规则，如果对方地址USDT为0，交易需要双倍131000的能量")
            ])
          ], -1))
        ])
      ]),
      _createElementVNode("section", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.changBtn(1))),
            class: _normalizeClass(_ctx.exNumber==1?'activeBtn':'')
          }, "TRX/USDT", 2),
          _createElementVNode("span", {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changBtn(2))),
            class: _normalizeClass(_ctx.exNumber==2?'activeBtn':'')
          }, "CNY/USDT", 2)
        ]),
        _cache[59] || (_cache[59] = _createElementVNode("h3", null, "数字币兑换（TRX/USDT）", -1)),
        _cache[60] || (_cache[60] = _createElementVNode("h4", null, "兑换数量 = （接收数量 × 市场汇率 - 手续费）", -1)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", null, _toDisplayString(_ctx.isUSDT?'USDT':'TRX'), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.exchangTRXamount) = $event)),
                  onInput: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.inputChange && _ctx.inputChange(...args)))
                }, null, 544), [
                  [_vModelText, _ctx.exchangTRXamount]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: "chang",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.changType()))
                }, _cache[56] || (_cache[56] = [
                  _createElementVNode("img", { src: _imports_4 }, null, -1)
                ])),
                _cache[57] || (_cache[57] = _createElementVNode("div", { class: "ex" }, [
                  _createElementVNode("img", { src: _imports_5 })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", null, _toDisplayString(_ctx.isUSDT?'TRX':'USDT'), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.TRXgetMoney) = $event)),
                  disabled: "",
                  class: "inputDisabled"
                }, null, 512), [
                  [_vModelText, _ctx.TRXgetMoney]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[58] || (_cache[58] = _createElementVNode("strong", null, "平台收款地址", -1)),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", null, _toDisplayString(_ctx.config.collection_exchange_address), 1),
              _createElementVNode("img", {
                src: _imports_3,
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.copyText(_ctx.config.collection_exchange_address||'')))
              })
            ])
          ])
        ]),
        _cache[61] || (_cache[61] = _createElementVNode("div", { class: "note" }, [
          _createElementVNode("h5", null, "兑换说明："),
          _createElementVNode("span", null, "您只需要将TRX或USDT转到平台账户地址，平台收到您的转账后将自动给你转会对应数量的USDT或TRX币。"),
          _createElementVNode("h5", null, "兑换限额："),
          _createElementVNode("span", null, "最低5U/50TRX起换，否则兑换失败。")
        ], -1))
      ]),
      _createElementVNode("section", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("span", {
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.changBtn(1))),
            class: _normalizeClass(_ctx.exNumber==1?'activeBtn':'')
          }, "TRX/USDT", 2),
          _createElementVNode("span", {
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.changBtn(2))),
            class: _normalizeClass(_ctx.exNumber==2?'activeBtn':'')
          }, "CNY/USDT", 2)
        ]),
        _cache[68] || (_cache[68] = _createElementVNode("h3", null, "USDT人民币汇率查询（USDT/CNY）", -1)),
        _createElementVNode("h4", null, "1USDT ≈ " + _toDisplayString(Number(_ctx.USDTPrice)!==0?_ctx.USDTPrice:7.1) + "人民币", 1),
        _createElementVNode("div", _hoisted_24, "更新时间：" + _toDisplayString(_ctx.formattedDate), 1),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("span", null, _toDisplayString(_ctx.usdtExChangeType==0?'USDT':'CNY'), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  onInput: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.getexchangMoney && _ctx.getexchangMoney(...args))),
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.exchangUSDTamount) = $event))
                }, null, 544), [
                  [_vModelText, _ctx.exchangUSDTamount]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", {
                  class: "chang",
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.changType2 && _ctx.changType2(...args)))
                }, _cache[62] || (_cache[62] = [
                  _createElementVNode("img", { src: _imports_4 }, null, -1)
                ])),
                _cache[63] || (_cache[63] = _createElementVNode("div", { class: "ex" }, [
                  _createElementVNode("img", { src: _imports_5 })
                ], -1))
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", null, _toDisplayString(_ctx.usdtExChangeType==0?'CNY':'USDT'), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.USDTgetMoney) = $event)),
                  disabled: ""
                }, null, 512), [
                  [_vModelText, _ctx.USDTgetMoney]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[66] || (_cache[66] = _createElementVNode("strong", null, "填写手续费", -1)),
            _createElementVNode("div", _hoisted_32, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.gassFei) = $event)),
                type: "number",
                onInput: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.getexchangMoney && _ctx.getexchangMoney(...args)))
              }, null, 544), [
                [_vModelText, _ctx.gassFei]
              ]),
              _cache[64] || (_cache[64] = _createTextVNode()),
              _cache[65] || (_cache[65] = _createElementVNode("i", null, "%", -1))
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "consult",
          onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.getexchangMoney && _ctx.getexchangMoney(...args)))
        }, " 转换 "),
        _createElementVNode("div", _hoisted_33, [
          _cache[67] || (_cache[67] = _createElementVNode("h5", null, "货币兑换后：", -1)),
          _createElementVNode("span", null, "得到 " + _toDisplayString(_ctx.USDTgetMoney) + " " + _toDisplayString(_ctx.usdtExChangeType==0?'人民币':'USDT'), 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_34, [
        _cache[72] || (_cache[72] = _createElementVNode("h3", null, "USDT人民币汇率查询", -1)),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", null, "1 USDT = " + _toDisplayString(Number(_ctx.USDTPrice)!==0?_ctx.USDTPrice:7.1) + " 人民币", 1),
            _createElementVNode("div", {
              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.getUSDTPrice(1)))
            }, "获取最新的USDT价格")
          ]),
          _createElementVNode("div", _hoisted_37, " 更新时间：" + _toDisplayString(_ctx.formattedDate), 1)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_el_form, { "label-width": "20vw" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "类型",
                  "label-position": "right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.usdtExChangeType,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.usdtExChangeType) = $event)),
                      placeholder: "Select",
                      size: "large",
                      onChange: _ctx.getexchangMoney
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exchangeUSDT, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "数量",
                  "label-position": "right",
                  style: {"margin":"6vw 0"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.exchangUSDTamount,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.exchangUSDTamount) = $event)),
                      onInput: _ctx.getexchangMoneyPhone,
                      min: 0,
                      style: {"height":"40px","width":"40vw"}
                    }, null, 8, ["modelValue", "onInput"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "手续费",
                  "label-position": "right"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.gassFei,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.gassFei) = $event)),
                      onInput: _ctx.getexchangMoney,
                      type: "number",
                      style: {"width":"25vw","height":"38px","margin-right":"2vw"}
                    }, null, 8, ["modelValue", "onInput"]),
                    _cache[69] || (_cache[69] = _createTextVNode(" % "))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      onClick: _ctx.getexchangMoney,
                      style: {"width":"30vw","height":"40px"}
                    }, {
                      default: _withCtx(() => _cache[70] || (_cache[70] = [
                        _createTextVNode("转换")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _cache[71] || (_cache[71] = _createElementVNode("div", { class: "resultTitle" }, "货币兑换后：", -1)),
          _createElementVNode("div", _hoisted_41, "得到 " + _toDisplayString(_ctx.USDTgetMoney) + " " + _toDisplayString(_ctx.usdtExChangeType==0?'人民币':'USDT'), 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_42, [
        _cache[79] || (_cache[79] = _createElementVNode("h3", null, "钱包多签", -1)),
        _cache[80] || (_cache[80] = _createElementVNode("h4", null, "请按照要求输入，才能确保操作成功", -1)),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _cache[73] || (_cache[73] = _createElementVNode("span", null, "待修改地址", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.signaturesData.address1) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.signaturesData.address1]
                ])
              ]),
              _cache[75] || (_cache[75] = _createElementVNode("div", { class: "icon" }, [
                _createElementVNode("div", { class: "ex" }, [
                  _createElementVNode("img", { src: _imports_6 })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_47, [
                _cache[74] || (_cache[74] = _createElementVNode("span", null, "私钥或助记词", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.signaturesData.key1) = $event)),
                  onBlur: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.key1change && _ctx.key1change(...args))),
                  type: "text"
                }, null, 544), [
                  [_vModelText, _ctx.signaturesData.key1]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _cache[76] || (_cache[76] = _createElementVNode("span", null, "控制地址", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.signaturesData.address2) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, _ctx.signaturesData.address2]
                ])
              ]),
              _cache[78] || (_cache[78] = _createElementVNode("div", { class: "icon" }, [
                _createElementVNode("div", { class: "ex" }, [
                  _createElementVNode("img", { src: _imports_6 })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_51, [
                _cache[77] || (_cache[77] = _createElementVNode("span", null, "私钥或助记词", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.signaturesData.key2) = $event)),
                  onBlur: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.key2change && _ctx.key2change(...args))),
                  type: "text"
                }, null, 544), [
                  [_vModelText, _ctx.signaturesData.key2]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "submit",
            onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, "提交")
        ]),
        _cache[81] || (_cache[81] = _createElementVNode("div", { class: "note" }, [
          _createElementVNode("h5", null, "多签说明："),
          _createElementVNode("span", null, " 请保证您的账户内至少有 100 TRX，每次修改权限波场会收取 100 TRX 费用")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _cache[84] || (_cache[84] = _createElementVNode("img", {
            src: _imports_7,
            class: "logo logo_left"
          }, null, -1)),
          _createElementVNode("div", _hoisted_54, [
            _cache[83] || (_cache[83] = _createElementVNode("h3", null, "最新接收记录", -1)),
            _createElementVNode("ul", null, [
              _cache[82] || (_cache[82] = _createElementVNode("li", { class: "header" }, [
                _createElementVNode("span", { class: "address" }, "接收地址"),
                _createElementVNode("span", { class: "isPc" }, "兑换类型"),
                _createElementVNode("span", null, "接收数量")
              ], -1)),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", {
                  style: _normalizeStyle(_ctx.listStyle)
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordList, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createElementVNode("span", null, _toDisplayString(item.address), 1),
                      _createElementVNode("span", _hoisted_56, _toDisplayString(item.changeType), 1),
                      _createElementVNode("span", null, _toDisplayString(item.receiveAmount), 1)
                    ]))
                  }), 128))
                ], 4)
              ])
            ])
          ]),
          _cache[85] || (_cache[85] = _createElementVNode("img", {
            src: _imports_7,
            class: "logo logo_right"
          }, null, -1))
        ])
      ]),
      _cache[87] || (_cache[87] = _createStaticVNode("<div id=\"about\" class=\"about\" data-v-31700806><div class=\"pageWidth\" data-v-31700806><h3 data-v-31700806>平台介绍</h3><ul class=\"icons\" data-v-31700806><li data-v-31700806><div data-v-31700806><img src=\"" + _imports_8 + "\" data-v-31700806></div><span data-v-31700806>经济</span></li><li data-v-31700806><div data-v-31700806><img src=\"" + _imports_9 + "\" data-v-31700806></div><span data-v-31700806>安全</span></li><li data-v-31700806><div data-v-31700806><img src=\"" + _imports_10 + "\" data-v-31700806></div><span data-v-31700806>高效</span></li></ul><div class=\"introduce\" data-v-31700806> 平台是波场生态中的能量兑换平台。我们的宗旨是为波场交易者降低能量消耗所需TRX费用。兑换流程简单快捷，价格优惠，24小时为您提供更安全且高效的能量兑换服务，Tg在线客服：https://t.me/Trxtw_bot 。 </div><ul class=\"aboutD\" data-v-31700806><li data-v-31700806><img src=\"" + _imports_11 + "\" data-v-31700806><span data-v-31700806>解决 TRX 手续费过高问题</span></li><li data-v-31700806><img src=\"" + _imports_11 + "\" data-v-31700806><span data-v-31700806>快捷方便，只需转账即可兑换能量</span></li><li data-v-31700806><img src=\"" + _imports_11 + "\" data-v-31700806><span data-v-31700806>适用USDT、合约转账、部署合约等</span></li><li data-v-31700806><img src=\"" + _imports_11 + "\" data-v-31700806><span data-v-31700806>Tron 波场用户必备省钱专家</span></li></ul></div></div><div id=\"faqDiv\" class=\"faqDiv\" data-v-31700806><div class=\"pageWidth\" data-v-31700806><h3 data-v-31700806>FAQ 常见问题</h3><ul data-v-31700806><li data-v-31700806><div class=\"icobD\" data-v-31700806><img class=\"icon\" src=\"" + _imports_12 + "\" data-v-31700806></div><img class=\"icon_b\" src=\"" + _imports_13 + "\" data-v-31700806><h4 data-v-31700806>如何购买次数</h4><span data-v-31700806>请在本页站头部中填写购买信息，然后根据提示向平台账户转入对应的TRX/USDT即可。</span></li><li data-v-31700806><div class=\"icobD\" data-v-31700806><img class=\"icon\" src=\"" + _imports_14 + "\" data-v-31700806></div><img class=\"icon_b\" src=\"" + _imports_15 + "\" data-v-31700806><h4 data-v-31700806>支付成功后，能量什么时候到账？</h4><span data-v-31700806>付款完成后，正常情况下能量会在6秒内到账。由于广播延迟等原因，极少数情况，会存在30到60秒的延迟。若没收到能量，请联系客服处理。</span></li><li data-v-31700806><div class=\"icobD\" data-v-31700806><img class=\"icon\" src=\"" + _imports_16 + "\" data-v-31700806></div><img class=\"icon_b\" src=\"" + _imports_17 + "\" data-v-31700806><h4 data-v-31700806>同一接收地址同时可以几笔订单？</h4><span data-v-31700806>同一地址也可以多笔购买，不限制使用次数。</span></li><li data-v-31700806><div class=\"icobD\" data-v-31700806><img class=\"icon\" src=\"" + _imports_18 + "\" data-v-31700806></div><img class=\"icon_b\" src=\"" + _imports_19 + "\" data-v-31700806><h4 data-v-31700806>订单可以撤回吗？</h4><span data-v-31700806>当您向平台账户支付费用后，订单不支持撤回。</span></li></ul></div></div>", 2))
    ]),
    _cache[89] || (_cache[89] = _createElementVNode("footer", null, " 便捷省钱服务平台 ", -1))
  ]))
}